import { Component, ElementRef, ViewChild } from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-upload-or-enter-code-dialog',
    templateUrl: './upload-or-enter-code-dialog.component.html',
    styleUrls: ['./upload-or-enter-code-dialog.component.scss'],
    standalone: false
})
export class UploadOrEnterCodeDialogComponent {
  @ViewChild('requestCodeText') requestCodeText: ElementRef;
  form: UntypedFormGroup;
  constructor(private readonly formBuilder: UntypedFormBuilder,
              private readonly dialogRef: MatDialogRef<UploadOrEnterCodeDialogComponent>) {
    this.form = this.formBuilder.group({
      code: ['', Validators.required]
    });
  }

    clearText(input, event) {
        this.form.controls['code'].setValue('');
        input.value = "";
        input.blur();
        event.stopPropagation();
    }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick() {
    this.dialogRef.close(this.form.value.code);
  }

  onUploadClick(event) {
    const fileInput = event.target;
    const file = fileInput.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      this.form.controls['code'].setValue(reader.result);
    };
    reader.readAsText(file)

    // Reset the file input value to allow re-selection of the same file
    fileInput.value = '';
  }
}
